// TargetAudience.js
import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Heart } from 'lucide-react';

const TargetAudience = () => {
  const audiences = [
    {
      icon: Users,
      text: 'Students heading overseas for a first degree or for postgraduate study'
    },
    {
      icon: Briefcase,
      text: 'Working professionals adding a qualification to move a career forward'
    },
    {
      icon: Heart,
      text: 'Parents helping a son or daughter plan an education outside the country'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Side - Heading */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary">
              Who We Built This For
            </h2>
          </motion.div>
          
          {/* Right Side - Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-6">
              Three groups tend to come to us:
            </p>
            
            <div className="space-y-4 mb-6">
              {audiences.map((audience, index) => {
                const Icon = audience.icon;
                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.2 + (index * 0.1) }}
                    className="flex items-start gap-3"
                  >
                    <Icon size={20} className="text-gray-600 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-600 text-sm font-light">{audience.text}</span>
                  </motion.div>
                );
              })}
            </div>
            
            <p className="text-gray-600 text-sm font-light leading-relaxed">
              If none of that feels settled yet, or you simply do not know where to start, the consultation exists to work out which route makes sense for you.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
